export default "/images/times-red.svg?eef11a0fc72156d4f90db5c435286803";